export default {
  title: 'Create data source',
};
